const ITEMS = [
    "Captive Bred Reptiles",
    "Documented Bloodlines",
    "Rare & Venomous",
    "Tarantulas & Dart Frogs",
    "Monitors & Exotic Mammals",
    "Naturalist Craftsmanship",
    "Live Arrival Guarantee",
    "Overnight Air Freight",
];

export const EditorialMarquee = () => {
    const row = [...ITEMS, ...ITEMS];
    return (
        <div
            data-testid="editorial-marquee"
            className="relative overflow-hidden border-y border-red-950/60 bg-coal/60 py-5"
        >
            <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
                {[...row, ...row].map((item, i) => (
                    <span key={i} className="flex items-center gap-10">
                        <span className="font-editorial text-xl uppercase tracking-[0.3em] text-red-900/70 sm:text-2xl">
                            {item}
                        </span>
                        <span className="h-1.5 w-1.5 rotate-45 bg-red-900/60" />
                    </span>
                ))}
            </div>
        </div>
    );
};
